import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ConfirmationDialog({ isOpen, onClose, onConfirm, title, message }) {
    const { t } = useTranslation();
    
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="confirmation-dialog">
                <h3>{title}</h3>
                <p>{message}</p>
                <div className="dialog-buttons">
                    <button className="cancel-button" onClick={onClose}>
                        {t('common.buttons.cancel')}
                    </button>
                    <button className="confirm-button" onClick={onConfirm}>
                        {t('common.buttons.confirm')}
                    </button>
                </div>
            </div>
        </div>
    );
} 